import { H3, H3KR } from 'global-styles';
import styled from 'styled-components';

export const ProductCommonTitleEn = styled(H3)`
  padding-top: 32px;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 24px;
  & + & {
    padding-top: 0;
  }
`;
export const ProductCommonTitleKR = styled(H3KR)`
  padding-top: 32px;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 24px;
  & + & {
    padding-top: 0;
  }
`;
